// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#autocomplete-wrapper, #autocomplete-input {
  width: 100%;
  position: relative;
  display: flex;
}
#autocomplete-wrapper .close, #autocomplete-input .close {
  position: absolute;
  right: 30px;
  font-size: 14px;
  width: 32px !important;
  height: 32px;
  top: 4px;
  cursor: pointer;
}

.search {
  z-index: 1000;
  cursor: pointer;
  background-color: #fff;
  font-family: sans-serif;
  opacity: 0.98;
  border-radius: 5px;
}

mark {
  background-color: transparent !important;
  font-weight: bold !important;
}

.search-result {
  padding: 4px 10px;
  font-size: 15px;
}
.search-result:first-child {
  border-left: 2px solid #133AA5;
}
.search-result:hover {
  background-color: #eceffe;
}

form {
  width: 100%;
}

.form-textarea {
  width: 100%;
  min-height: 120px;
  color: #333 !important;
  border: 2px solid #e0e0e0 !important;
  margin: 0 0 8px 0;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  transition: all 0.3s ease;
  resize: vertical;
}
.form-textarea:focus {
  outline: none;
  border-color: #82b7e1 !important;
  box-shadow: 0 0 0 3px rgba(130, 183, 225, 0.1);
}
.form-textarea::placeholder {
  color: #999 !important;
  text-transform: capitalize;
}

.error-message {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #dc3545;
  font-size: 13px;
  margin-top: 4px;
  font-weight: 500;
}
.error-message i {
  font-size: 14px;
}

.action-buttons {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
  gap: 12px;
  flex-wrap: wrap;
}

.button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
}
.button i {
  font-size: 16px;
}
.button:not(:disabled):hover {
  transform: translateY(-1px);
}
.button:not(:disabled):active {
  transform: translateY(0);
}

.btn-group {
  display: flex;
  gap: 10px;
  margin-left: auto;
}

.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 9999;
}

#suggestion-list {
  width: inherit;
  font-size: 0.9rem !important;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 2px 2px, rgba(0, 0, 0, 0.09) 0px 2px 4px, rgba(0, 0, 0, 0.09) 0px 2px 8px, rgba(0, 0, 0, 0.09) 0px 2px 5px;
  max-height: 200px;
  overflow-y: auto;
  position: absolute;
  z-index: 99;
  top: 43px;
}
#suggestion-list p {
  padding: 10px;
}

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}`, "",{"version":3,"sources":["webpack://./src/app/components/summarize/summarize-content/summarize-content.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,kBAAA;EACA,aAAA;AACF;AACE;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,QAAA;EACA,eAAA;AACJ;;AAGA;EACE,aAAA;EACA,eAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;AAAF;;AAGA;EACE,wCAAA;EACA,4BAAA;AAAF;;AAGA;EACE,iBAAA;EACA,eAAA;AAAF;AAEE;EACE,8BAAA;AAAJ;AAGE;EACE,yBAAA;AADJ;;AAKA;EACE,WAAA;AAFF;;AAKA;EACE,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,oCAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,yBAAA;EACA,gBAAA;AAFF;AAIE;EACE,aAAA;EACA,gCAAA;EACA,8CAAA;AAFJ;AAKE;EACE,sBAAA;EACA,0BAAA;AAHJ;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AAJF;AAME;EACE,eAAA;AAJJ;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,SAAA;EACA,eAAA;AALF;;AAQA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;AALF;AAOE;EACE,eAAA;AALJ;AAQE;EACE,2BAAA;AANJ;AASE;EACE,wBAAA;AAPJ;;AAWA;EACE,aAAA;EACA,SAAA;EACA,iBAAA;AARF;;AAWA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;AARF;;AAWA;EACE,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,+KAAA;EAGA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AAVF;AAYE;EACE,aAAA;AAVJ;;AAcA;EACE,UAAA;AAXF;;AAcA;EACE,mBAAA;EACA,kBAAA;AAXF;;AAcA;EACE,mBAAA;EACA,kBAAA;AAXF;AAaE;EACE,mBAAA;AAXJ","sourcesContent":["#autocomplete-wrapper, #autocomplete-input {\n  width: 100%;\n  position: relative;\n  display: flex;\n  \n  .close {\n    position: absolute;\n    right: 30px;\n    font-size: 14px;\n    width: 32px !important;\n    height: 32px;\n    top: 4px;\n    cursor: pointer;\n  }\n}\n\n.search {\n  z-index: 1000;\n  cursor: pointer;\n  background-color: #fff;\n  font-family: sans-serif;\n  opacity: 0.98;\n  border-radius: 5px;\n}\n\nmark {\n  background-color: transparent !important;\n  font-weight: bold !important;\n}\n\n.search-result {\n  padding: 4px 10px;\n  font-size: 15px;\n  \n  &:first-child {\n    border-left: 2px solid #133AA5;\n  }\n  \n  &:hover {\n    background-color: #eceffe;\n  }\n}\n\nform {\n  width: 100%;\n}\n\n.form-textarea {\n  width: 100%;\n  min-height: 120px;\n  color: #333 !important;\n  border: 2px solid #e0e0e0 !important;\n  margin: 0 0 8px 0;\n  padding: 12px 16px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-family: inherit;\n  transition: all 0.3s ease;\n  resize: vertical;\n  \n  &:focus {\n    outline: none;\n    border-color: #82b7e1 !important;\n    box-shadow: 0 0 0 3px rgba(130, 183, 225, 0.1);\n  }\n  \n  &::placeholder {\n    color: #999 !important;\n    text-transform: capitalize;\n  }\n}\n\n.error-message {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #dc3545;\n  font-size: 13px;\n  margin-top: 4px;\n  font-weight: 500;\n  \n  i {\n    font-size: 14px;\n  }\n}\n\n.action-buttons {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 16px;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.button {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.2s ease;\n  \n  i {\n    font-size: 16px;\n  }\n  \n  &:not(:disabled):hover {\n    transform: translateY(-1px);\n  }\n  \n  &:not(:disabled):active {\n    transform: translateY(0);\n  }\n}\n\n.btn-group {\n  display: flex;\n  gap: 10px;\n  margin-left: auto;\n}\n\n.spinner-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(255, 255, 255, 0.8);\n  z-index: 9999;\n}\n\n#suggestion-list {\n  width: inherit;\n  font-size: 0.9rem !important;\n  border-radius: 5px;\n  box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 2px 2px, \n              rgba(0, 0, 0, 0.09) 0px 2px 4px, rgba(0, 0, 0, 0.09) 0px 2px 8px, \n              rgba(0, 0, 0, 0.09) 0px 2px 5px;\n  max-height: 200px;\n  overflow-y: auto;\n  position: absolute;\n  z-index: 99;\n  top: 43px;\n  \n  p {\n    padding: 10px;\n  }\n}\n\n::-webkit-scrollbar {\n  width: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 4px;\n  \n  &:hover {\n    background: #a8a8a8;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
